/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Faq_3_AInputs */

const en_serve_faq_3_a = /** @type {(inputs: Serve_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Building pauses when the laptop sleeps and continues when it wakes. The phone preview needs the laptop on. Publishing keeps working: Bystep stores a copy after every finished step.`)
};

const id_serve_faq_3_a = /** @type {(inputs: Serve_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembangunan berhenti sementara saat laptop tidur dan lanjut saat bangun. Tampilan di HP butuh laptop menyala. Terbitkan tetap jalan: Bystep menyimpan salinan setiap kali satu langkah selesai.`)
};

/**
* | output |
* | --- |
* | "Building pauses when the laptop sleeps and continues when it wakes. The phone preview needs the laptop on. Publishing keeps working: Bystep stores a copy aft..." |
*
* @param {Serve_Faq_3_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_faq_3_a = /** @type {((inputs?: Serve_Faq_3_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Faq_3_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_faq_3_a(inputs)
	return en_serve_faq_3_a(inputs)
});